import {Button, ButtonProps, useStyleConfig, useMediaQuery} from '@chakra-ui/react';
import React, {memo, MouseEventHandler} from 'react';

interface Props extends ButtonProps {
  title?: string;
  selected?: boolean;
  scrollAmount?: number;
}

// variant?: 'primary' | 'white' | 'toggle' | 'outline' | 'solid';
export const ScrollToBottomButton = memo(
  React.forwardRef<HTMLButtonElement, Props>(
    ({title, children, variant = 'primary', scrollAmount = 99999, onClick, ...rest}: Props, ref) => {
      const bntTitle = title || children;
      const styles = useStyleConfig('Button', {variant});

      const scrollToBottom = () => {
        setTimeout(() => {
          window.scrollTo({top: scrollAmount, behavior: 'smooth'});
        }, 200);
      };

      const handleClick = (e: any) => {
        if (onClick) {
          // scrollToBottom();
          onClick(e);
        }
      };

      return (
        <Button ref={ref} onClick={handleClick} {...rest} __css={styles}>
          {bntTitle}
        </Button>
      );
    },
  ),
);
